import {
  IRiskAssessmentForm,
  IRiskAssessmentFormPostObject,
  IRiskAssessmentFormPostPayload,
} from "./interfaces/DataInterfaces";
import restApiService from "./restApiService";

export class dynamicFormRepository {
  static GetDynamicFormsByTemplateId = async (
    templateId: number
  ): Promise<IRiskAssessmentForm[]> => {
    let result: [] = [];
    await restApiService
      .get(`templateForms/${templateId}`)
      .then((response) => {
        if (response?.Status === 200) {
          result = response?.data?.map((x: any) => {
            return {
              ...x,
              fieldSchema: JSON.parse(x.fieldSchema),
              uiSchema: JSON.parse(x.uiSchema),
              dataJson: JSON.parse(x.dataJson),
            };
          });
        }
      })
      .catch((error) => {
        console.log("exception on api/templateForms API call : " + error);
      });
    return result;
  };

  static GetDynamicFormsByCaseId = async (
    caseId: number
  ): Promise<IRiskAssessmentForm[]> => {
    let result: [] = [];
    await restApiService
      .get(`caseForms/${caseId}`)
      .then((response) => {
        if (response?.Status === 200) {
          result = response?.data?.map((x: any) => {
            return {
              ...x,
              fieldSchema: JSON.parse(x.fieldSchema),
              uiSchema: JSON.parse(x.uiSchema),
              dataJson: JSON.parse(x.dataJson),
            };
          });
        }
      })
      .catch((error) => {
        console.log("exception on api/templateForms API call : " + error);
      });
    return result;
  };

  static PostDynamicFormsForSuperUser = async (
    data: IRiskAssessmentFormPostObject
  ): Promise<any> => {
    let result: string = "Error";
    let payload: IRiskAssessmentFormPostPayload = {
      dataJson: data.dataJson ? JSON.stringify(data.dataJson) : null,
      description: data.description,
      fieldSchema: JSON.stringify(data.fieldSchema),
      formName: data.formName,
      isFormTypeArray: data.isFormTypeArray,
      templateId: data.templateId,
      uiSchema: JSON.stringify(data.uiSchema),
      updatedBy: data.updatedBy,
    };
    await restApiService
      .post(`templateForm`, payload)
      .then((response) => {
        if (response?.status === 200) {
          result = response?.message;
        }
      })
      .catch((error) => {
        console.log("exception on POST api/templateForms API call : " + error);
      });
    return result;
  };

  static SaveTemplateFormData = async ({
    templateId,
    templateFormId,
    masterFormId,
    dataJson,
    offsetInMinutes,
  }: {
    templateId: number;
    templateFormId: number | undefined;
    masterFormId: number;
    dataJson: {} | null;
    offsetInMinutes: number;
  }): Promise<any> => {
    let result: string = "Error";
    await restApiService
      .put(`templateForm`, {
        templateId: templateId,
        templateFormId: templateFormId,
        masterFormId: masterFormId,
        dataJson:
          dataJson === null || Object.keys(dataJson).length === 0
            ? null
            : JSON.stringify(dataJson),
        offsetInMinutes: offsetInMinutes,
      })
      .then((response) => {
        if (response?.status === 200) {
          result = response?.message;
        }
      })
      .catch((error) => {
        console.log("exception on PUT api/templateForms API call : " + error);
      });
    return result;
  };

  static SaveCaseFormData = async ({
    caseId,
    caseFormId,
    masterFormId,
    dataJson,
  }: {
    caseId: number;
    caseFormId: number | undefined;
    masterFormId: number;
    dataJson: {} | null;
  }): Promise<any> => {
    let result: string = "Error";
    await restApiService
      .put(`caseForm`, {
        caseId: caseId,
        caseFormId: caseFormId,
        masterFormId: masterFormId,
        dataJson:
          dataJson === null || Object.keys(dataJson).length === 0
            ? null
            : JSON.stringify(dataJson),
      })
      .then((response) => {
        if (response?.status === 200) {
          result = response?.message;
        }
      })
      .catch((error) => {
        console.log("exception on PUT api/templateForms API call : " + error);
      });
    return result;
  };
}
